// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__RmHd9","contentContainer":"styles_contentContainer__zwhBZ","backBtn":"styles_backBtn__+ywY-"};